module.exports = __webpack_public_path__ + "static/media/Noklene.646c6cd2.mp3";